export const buildQueryString = (filters = {}) => {
  const query = new URLSearchParams();

  for (const key in filters) {
    const value = filters[key];

    // Handle nested keys like paginate[per_page]
    if (typeof value === 'object' && value !== null) {
      for (const subKey in value) {
        query.append(`${key}[${subKey}]`, value[subKey]);
      }
    } else if (value !== undefined && value !== "") {
      query.append(key, value);
    }
  }

  return query.toString();
};